import { getThemeFromLocal, saveThemeToLocal } from '@/utils/theme'

const state = {
  currentTheme: getThemeFromLocal() || 'light',
  availableThemes: ['light', 'dark', 'blue', 'green']
}

const getters = {
  currentTheme: state => state.currentTheme,
  availableThemes: state => state.availableThemes,
  isDark: state => state.currentTheme === 'dark'
}

const mutations = {
  SET_THEME(state, theme) {
    state.currentTheme = theme
  },
  SET_AVAILABLE_THEMES(state, themes) {
    state.availableThemes = themes
  }
}

const actions = {
  switchTheme({ commit }, theme) {
    commit('SET_THEME', theme)
    saveThemeToLocal(theme)
    applyThemeToDOM(theme)
  },

  toggleDarkMode({ state, dispatch }) {
    const next = state.currentTheme === 'dark' ? 'light' : 'dark'
    dispatch('switchTheme', next)
  }
}

function applyThemeToDOM(theme) {
  document.documentElement.setAttribute('data-theme', theme)
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
